const TIMEOUT_ERROR_CODE = 401;

export default function (errorCode) {
  return errorCode === TIMEOUT_ERROR_CODE;
}
